import { Box, Grid, GridItem, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, useDisclosure } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { getPostList } from '../../../service';

type Props = {
  term: string
};

function ParticipationContentItemSciforumViewPoster({ term }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { isLoading, error, data } = useQuery('ParticipationContentItemSciforumViewPost', () => getPostList('sciforumtag', 'sciforumtag_cat', term));

  const openModal = (index:number) => {		
    setSelectedIndex(index);
    onOpen();
  }

  return (
    <>
    {
      !isLoading && !error && data && data.length === 0 && (
        <Box textAlign="center" pt="5" pb="5">
          <Text>
            포스터가 없습니다.
          </Text>
        </Box>
      )
    }
    {
      !isLoading && !error && data && data.length > 0 && (
        <>
        <Grid templateColumns='repeat(4, 1fr)' gap={6}>
        {
          data.map((item: any, index: number) => (
            <button onClick={() => openModal(index)}>
              <GridItem w='100%' key={index} borderStyle="solid" borderWidth="1px" borderColor="b.lg">
                <Image src={item.featured_medium} objectFit="cover" w="100%" maxH="300" />
                <Text p="4">
                  {item.title}
                </Text>
              </GridItem>
            </button>
          ))
        }
        </Grid>
        <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              {data[selectedIndex].title}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box>
                <Image src={data[selectedIndex].featured_full} objectFit="cover" w="100%" />
              </Box>
              <Box textAlign="center" pt="5" pb="5" dangerouslySetInnerHTML={ {__html: data[selectedIndex].content} } />
            </ModalBody>       
          </ModalContent>
        </Modal>
        </>
      )
    }
    </>
  );
}

ParticipationContentItemSciforumViewPoster.defaultProps = {
};

export default ParticipationContentItemSciforumViewPoster;
